<template>
  <div>
    <main>
      <!-- <CreateOrg v-if="user?.organizationMemberships.length === 0" /> -->
      <!-- <div v-if="user?.organizationMemberships.length === 0">
        Creating organization...
      </div> -->
      <div v-if="!hasActiveOrg" class="flex h-dvh items-center justify-center">
        <OrganizationList
          v-if="hasOrgMemberships"
          :hide-personal="true"
          :skipInvitationScreen="true"
          :hide-slug="true"
        />
        <!-- <Card v-else class="border">
          <template #title>
            <div class="w-80 pb-4">
              <IvyIcon class="" :withText="true" />
            </div>
            <div class="py-4 text-xxl font-medium">Create an organization</div>
          </template>
          <template #content>
            <LabeledField label="Organization name">
              <InputText v-model="orgName" fluid />
            </LabeledField>
          </template>
          <template #footer>
            <Button
              @click="createOrg"
              class="mt-4"
              icon="pi pi-plus"
              label="Create organization"
            />
          </template>
        </Card> -->
      </div>

      <div v-else class="h-dvh">
        <!-- hasOrgMemberships:{{ hasOrgMemberships }} -->
        <div
          class="mx-auto overflow-auto max-h-screen h-full bg-gray-100 dark:bg-zinc-950"
        >
          <div class="flex h-full">
            <TransitionRoot as="div" :show="sidebarOpen">
              <Dialog
                as="div"
                class="relative z-30 lg:hidden"
                @close="sidebarOpen = false"
              >
                <TransitionChild
                  as="template"
                  enter="transition-opacity ease-linear duration-300"
                  enter-from="opacity-0"
                  enter-to="opacity-100"
                  leave="transition-opacity ease-linear duration-300"
                  leave-from="opacity-100"
                  leave-to="opacity-0"
                >
                  <div class="fixed inset-0 bg-gray-900/80" />
                </TransitionChild>

                <div class="fixed inset-0 flex">
                  <TransitionChild
                    as="template"
                    enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full"
                    enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leave-from="translate-x-0"
                    leave-to="-translate-x-full"
                  >
                    <DialogPanel
                      class="relative mr-16 flex w-full max-w-xs flex-1"
                    >
                      <TransitionChild
                        as="template"
                        enter="ease-in-out duration-300"
                        enter-from="opacity-0"
                        enter-to="opacity-100"
                        leave="ease-in-out duration-300"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                      >
                        <div
                          class="absolute left-full top-0 flex w-16 justify-center pt-5"
                        >
                          <button
                            type="button"
                            class="-m-2.5 p-2.5"
                            @click="sidebarOpen = false"
                          >
                            <span class="sr-only">Close sidebar</span>
                            <XMarkIcon
                              class="h-6 w-6 text-white"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </TransitionChild>
                      <div
                        class="flex grow flex-col gap-y-5 overflow-y-auto bg-slate-50 dark:bg-slate-800"
                      >
                        <MainSidebar @close="sidebarOpen = false" />
                      </div>
                    </DialogPanel>
                  </TransitionChild>
                </div>
              </Dialog>
            </TransitionRoot>

            <!-- static sidebar for desktop -->
            <div class="hidden lg:block fixed w-56 z-20 h-full overflow-y-auto">
              <MainSidebar />
            </div>

            <!-- <div :class="['static w-full ', 'ml-0 lg:ml-60  z-1']">
              <router-view v-slot="{ Component }">
                <component :is="Component" />
              </router-view>
            </div> -->

            <div
              className="flex flex-1 flex-col pb-2 lg:min-w-0 lg:pl-56 lg:pr-2 lg:pt-2"
            >
              <!-- <div
                className="grow p-6 lg:rounded-lg lg:bg-white lg:p-10 lg:shadow-sm lg:ring-1 lg:ring-zinc-950/5 dark:lg:bg-zinc-900 dark:lg:ring-white/10"
              > -->
              <div
                className="grow  lg:rounded-lg overflow-hidden bg-white  lg:shadow-sm lg:ring-1 lg:ring-zinc-950/5 dark:bg-zinc-900 dark:lg:ring-white/10"
              >
                <!-- max-w-6xl -->
                <div className="mx-auto ">
                  <router-view v-slot="{ Component }">
                    <component :is="Component" />
                  </router-view>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>

  <NotificationArea />
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
// import { Splitpanes, Pane } from "splitpanes";
// import "splitpanes/dist/splitpanes.css";

// import CreateOrg from "../pages/CreateOrg.vue";

import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";

import NotificationArea from "@/components/NotificationArea.vue";

import _ from "lodash";
import { useStore } from "@/store";

import MainSidebar from "./MainSidebar.vue";
import { OrganizationList, useAuth, useUser, useClerk } from "@clerk/vue";
import { Button, Card, InputText } from "primevue";
import LabeledField from "@/components/workflows/LabeledField.vue";
import IvyIcon from "@/components/IvyIcon.vue";
import { notifyNegative } from "@/helperfunctions";

const { orgId } = useAuth();
const user = useUser();
const clerk = useClerk();

const hasActiveOrg = computed(() => orgId.value !== null);
const hasOrgMemberships = computed(
  () => user.user.value.organizationMemberships.length > 0
);

// import ApiKeyNudge from "@/components/ApiKeyNudge.vue";

const store = useStore();

// store.fetchProjects();

// always reset on load
store.side.show = false;

const sidebarOpen = ref(false);

watch(
  () => store.event,
  (newVal) => {
    if (newVal === "toggle-sidebar") {
      sidebarOpen.value = !sidebarOpen.value;
      store.event = null;
    }
  }
);

// const clerk = useClerk();

// function setActiveOrg() {
//   if (user.value?.organizationMemberships?.length > 0) {
//     let orgId = user.value.organizationMemberships[0].organization.id;
//     clerk.setActive({ organization: orgId }).catch((error) => {
//       console.error("Failed to set active organization:", error);
//     });
//   }
// }

// setActiveOrg();

// const clerk = useClerk();

// function createOrg() {
//   if (!user.value) {
//     return;
//   }
//   if (user.value?.organizationMemberships.length > 0) {
//     return;
//   }
//   clerk
//     .createOrganization("Personal")
//     .then((org) => {
//       console.log("Organization created:", org);
//     })
//     .catch((error) => {
//       console.error("Failed to create organization:", error);
//       console.error("Error details:", error.details);
//     });
// }

// createOrg();

// function getKeyState() {
//   store.fetchModelProviders();
// }

// getKeyState();

const orgName = ref("");

function createOrg() {
  if (!orgName.value) {
    notifyNegative("Please enter an organization name");
    return;
  }

  clerk.value
    .createOrganization({ name: orgName.value })
    .then((org) => {
      console.log("Organization created:", org);
      // setActive(org.id);

      clerk.value.setActive({ organization: org.id }).catch((error) => {
        console.error("Failed to set active organization:", error);
      });
    })
    .catch((error) => {
      console.error("Failed to create organization:", error);
      console.error("Error details:", error.details);
    });
}
</script>
